import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { FormikErrors } from 'formik'

import {
  dateAboveToday,
  onlyNumber,
  required,
  validDate,
} from '../../_utils/formValidators'
import { DateDurationInfoValues } from './DateDuration.view'

const validateValidityInYears = (validity: number) => {
  return required.default(validity) || onlyNumber.default(validity)
}

const validateDate = (stringDate: string) => {
  dayjs.extend(customParseFormat)
  const dateToValidate = dayjs(stringDate, 'DD.MM.YYYY')
  const dateJSON = dateToValidate.toObject()

  return (
    required.default(stringDate) ||
    validDate.default(dateJSON.date, dateJSON.months, dateJSON.years) ||
    dateAboveToday.default(dateToValidate.toDate())
  )
}

export const validateFieldForm = (formValueFields: DateDurationInfoValues) => {
  const errors: FormikErrors<DateDurationInfoValues> = {}

  if (validateDate(formValueFields.validityStartDate)) {
    errors.validityStartDate = validateDate(formValueFields.validityStartDate)
  }

  if (validateValidityInYears(formValueFields.validityInYears)) {
    errors.validityInYears = validateValidityInYears(
      formValueFields.validityInYears,
    )
  }

  return errors
}
